module.exports = __webpack_public_path__ + "static/media/course_ai.37d247d3.svg";